import React from 'react'

import AlarmComplete from '@Pages/alarm/complete'
import AlarmConfirm from '@Pages/alarm/confirm'
import AlarmModify from '@Pages/alarm/modify'
import AlarmLayout from '@Components/layout/alarm/AlarmLayout'

export default {
  layout: AlarmLayout,
  routes: [AlarmComplete, AlarmConfirm, AlarmModify],
}
